import { Waves, Bed, Utensils, HeartHandshake, Wifi, Coffee, Bath, Mountain, Users, Sparkles } from 'lucide-react';

export const availableAmenities = [
  { id: 'wifi', icon: Wifi, label: 'Free Wi-Fi' },
  { id: 'coffee', icon: Coffee, label: 'Breakfast' },
  { id: 'bath', icon: Bath, label: 'En-suite bath' },
  { id: 'mountain', icon: Mountain, label: 'Ocean view' },
  { id: 'users', icon: Users, label: 'Shared capacity' },
  { id: 'sparkles', icon: Sparkles, label: 'Premium linens' },
];

export let packages = [];


export const includedCategories = [
  {
    title: 'Accommodation',
    icon: Bed,
    items: [
      '7 Days Accommodation',
      'Cleaning & Fresh Towels',
      'Optical Fibre WiFi',
      'Use of TV, Netflix & Instruments'
    ]
  },
  {
    title: 'Activities',
    icon: Waves,
    items: [
      'Daily Guiding (2 sessions)',
      'Free Board & Wetsuit Use',
      '1 Surf Trip (North or South)',
      'Sunrise & Sunset Surf (on request)'
    ]
  },
  {
    title: 'Food & Drinks',
    icon: Utensils,
    items: [
      'Moroccan Breakfast ×7',
      'Lunch on the Beach ×7',
      'Moroccan Dinner ×6 (Sunday Off)',
      'BBQ Saturday'
    ]
  },
  {
    title: 'Services',
    icon: HeartHandshake,
    items: [
      'Airport Pick Up & Drop Off (7 Nights)',
      'Use of Skate & Surf Skate'
    ]
  }
];

export let rooms = [];
export let activities = [];
export let blogs = [];
export let products = [];

export const initData = async () => {
  try {
    const [packagesRes, roomsRes, activitiesRes, blogsRes, productsRes] = await Promise.all([
      fetch('/api/packages'),
      fetch('/api/rooms'),
      fetch('/api/activities'),
      fetch('/api/blogs'),
      fetch('/api/products')
    ]);
    
    if (packagesRes.ok) {
      const apiPackages = await packagesRes.json();
      const localPackages = JSON.parse(localStorage.getItem('sable_packages')) || [];
      const combined = [...localPackages, ...apiPackages];
      packages = Array.from(new Map(combined.map(item => [item.slug, item])).values());
    }
    
    if (roomsRes.ok) {
      const rawRooms = await roomsRes.json();
      const apiRooms = rawRooms.map(room => ({
        ...room,
        amenities: (room.amenities || []).map(a => {
          if (typeof a === 'string') {
            return availableAmenities.find(av => av.id === a) || { id: a, label: a, icon: Wifi };
          }
          return { ...a, icon: a.icon || availableAmenities.find(av => av.label === a.label)?.icon || Wifi };
        })
      }));
      const localRooms = JSON.parse(localStorage.getItem('sable_rooms')) || [];
      const combined = [...localRooms, ...apiRooms];
      rooms = Array.from(new Map(combined.map(item => [item.slug, item])).values());
    }
    
    if (activitiesRes.ok) {
      const apiActivities = await activitiesRes.json();
      const localActivities = JSON.parse(localStorage.getItem('sable_activities')) || [];
      const combined = [...localActivities, ...apiActivities];
      activities = Array.from(new Map(combined.map(item => [item.slug, item])).values());
    }

    if (blogsRes.ok) {
      const apiBlogs = await blogsRes.json();
      const localBlogs = JSON.parse(localStorage.getItem('sable_blogs')) || [];
      const combined = [...localBlogs, ...apiBlogs];
      blogs = Array.from(new Map(combined.map(item => [item.slug, item])).values());
    }

    if (productsRes.ok) {
      const apiProducts = await productsRes.json();
      const localProducts = JSON.parse(localStorage.getItem('sable_products')) || [];
      const combined = [...localProducts, ...apiProducts];
      products = Array.from(new Map(combined.map(item => [item.slug, item])).values());
    }
  } catch (error) {
    console.error("Failed to load initial data from API", error);
  }
};


export const schedule = [
  { time: '07:30', title: 'Sunrise Surf', desc: '(if guest wishes)' },
  { time: '09:00', title: 'Moroccan Healthy Breakfast', desc: '' },
  { time: '10:00', title: 'Roadtrip and Surf Spot Checking', desc: '' },
  { time: '12:30', title: 'Lunch at the Beach', desc: '' },
  { time: '13:30', title: 'Another surf or two', desc: 'Or even 3 if you are not beaten' },
  { time: '16:30', title: 'Out of the Surfspot', desc: '' },
  { time: '18:30', title: 'Sunset Restorative Yoga', desc: '(Optional)' },
  { time: '20:00', title: 'Moroccan 3 Course Meal', desc: '(Sunday dinners not Included)' },
  { time: '21:00', title: 'Terrace Chills', desc: 'Music, Society Games, Surf Discussion for the Next Day' },
];


